// Common
export const CUSTOM_EVENT_TYPE = 'custom-event'
export type Nullable<T> = T | null | undefined

/**
 * Represents JSON object and values
 */
export type JSONValue = string | number | boolean | JSONObject | JSONArray
export type JSONObject = {
    [x: string]: JSONValue
}
export type JSONArray = JSONValue[]
export type JSONType = JSONObject | JSONArray
